import { z } from 'zod';

import { apiClient } from './client';

// Зеркалит backend App\Enums\ApplicationStatus (pending/approved/rejected/
// withdrawn/expired). Раньше было 'accepted' (бэкенд шлёт 'approved') и не было
// approved/expired -> одобренная/просроченная заявка роняла парсинг списка.
export const ApplicationStatusZ = z.enum([
  'pending',
  'approved',
  'rejected',
  'withdrawn',
  'expired',
]);

export const ApplicationZ = z.object({
  id: z.number().int(),
  listing_id: z.number().int(),
  applicant_id: z.number().int(),
  message: z.string().nullable().optional(),
  status: ApplicationStatusZ,
  created_at: z.string(),
});
export type Application = z.infer<typeof ApplicationZ>;

const ListZ = z.object({ data: z.array(ApplicationZ) });

export async function listApplications(): Promise<Application[]> {
  const res = await apiClient.get('/applications');
  return ListZ.parse(res.data).data;
}

export async function withdrawApplication(id: number): Promise<void> {
  // backend -- POST /applications/{id}/withdraw (DELETE не существует -> 405/404).
  await apiClient.post(`/applications/${id}/withdraw`);
}

export const applicationsApi = { list: listApplications, withdraw: withdrawApplication };
